import {
	DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI,
	DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
} from '../../entities';
import { NounSubtypeKey, TypeFilterValueKey } from '../../filters/universal-type';
import { get3PLogo } from '../../icons';
import { type ThirdPartyConfig } from '../../schemas/3p-config';

import { LucidIcon } from './icon';
import { LucidSearchResultIcon } from './search-result-icon';

export const lucidConfig: ThirdPartyConfig = {
	displayName: 'Lucid',
	id: 'lucid',
	resourceType: 'lucid-connector',
	icon: get3PLogo(LucidIcon, 'Lucid', 'medium'),
	searchResultIcon: get3PLogo(LucidSearchResultIcon, 'Lucid', 'large'),
	integrationAri: 'ari:cloud:platform::integration/lucid',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Design,
			{
				entities3P: [
					...DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI,
					...DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
				],
				subTypes3P: [NounSubtypeKey.Design],
			},
		],
	]),
	filters: ['lastUpdated'],
	requiresOauth: false,
	isEnabled: () => true,
};
